// graphiql v5 bundles Monaco editor, which requires MonacoEnvironment to spawn web workers.
// Without this, Monaco falls back to the main thread → UI freezes and a TypeError crash in
// the JSON language worker (see GitHub issue #260).
declare global {
  interface Window {
    MonacoEnvironment?: {
      getWorker(workerId: string, label: string): Worker;
    };
  }
}

window.MonacoEnvironment = {
  getWorker(_workerId: string, label: string): Worker {
    if (label === 'graphql') {
      return new Worker(new URL('monaco-graphql/esm/graphql.worker', import.meta.url), {
        type: 'module',
      });
    }
    if (label === 'json') {
      return new Worker(
        new URL('monaco-editor/esm/vs/language/json/json.worker.js', import.meta.url),
        { type: 'module' }
      );
    }
    return new Worker(new URL('monaco-editor/esm/vs/editor/editor.worker.js', import.meta.url), {
      type: 'module',
    });
  },
};
